export const downloadBlob = (blob, title) => {
  const lnk = document.createElement("a");
  lnk.href = URL.createObjectURL(blob);
  // lnk.target = "_blank";
  lnk.download = title;
  lnk.click();
  URL.revokeObjectURL(lnk.href);
};

export const base64ToBytes = (base64) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};
